// extracted by mini-css-extract-plugin
module.exports = {"base":"CreditNotActiveModal_base__1pd4c","ModalText":"CreditNotActiveModal_ModalText__2eeXE"};